import { useState } from 'hooks'
import $ from 'jquery'
import { addClass, removeClass } from '@/utils/class'
import { editor } from '../../constant'
import { getDynamicTableComponents } from './selector'

type State = {
	questionnaireSelect?: HTMLSelectElement
	paginationSelect?: HTMLSelectElement
	typeSelects?: NodeListOf<HTMLSelectElement>
	settingSelects?: NodeListOf<HTMLSelectElement>
	settingSelectsContainers?: NodeListOf<HTMLDivElement>
	imageSubsettingsContainers?: NodeListOf<HTMLDivElement>
	showMoreSelect?: HTMLSelectElement
}

export const DynamicTable = (() => {
	const { state, setState } = useState<State>()

	const changeSelectOptions = (i: number, typeSelect: HTMLSelectElement) => {
		const { settingSelects, settingSelectsContainers } = state
		if (!settingSelects || !settingSelectsContainers) return

		const settingsInput = settingSelects[i]?.parentElement?.childNodes.item(0) as HTMLInputElement
		const inputsList = document.getElementById(settingsInput.getAttribute('data-target')) as HTMLUListElement
		const selectedOption = getSelectedOption(typeSelect)

		// @ts-ignore
		$.nette.ajax({
			type: 'POST',
			url: typeSelect.getAttribute(editor.editorComponentChangeHandler),
			data: {
				selectedType: selectedOption,
			},
			success: (payload: string) => {
				payload = JSON.parse(payload)

				if (payload.showImageSettings !== undefined) {
					decideImageSubsettings(payload.showImageSettings)
				}

				if (payload.subtypeSettings !== undefined) {
					changeSubtypeSelect(payload.subtypeSettings, inputsList, settingSelectsContainers[i], i)
				}
			},
		})
	}

	const changeSubtypeSelect = (
		subsettings: string[],
		inputsList: HTMLUListElement,
		settingSelectsContainer: HTMLDivElement,
		i: number,
	) => {
		if (subsettings.length === 0) {
			addClass(settingSelectsContainer, 'hidden')
		} else {
			removeClass(settingSelectsContainer, 'hidden')

			const { childNodes } = inputsList
			for (let j = 0; j < childNodes.length; j++) {
				const selects = childNodes.item(i) as HTMLLIElement
				removeClass(selects, 'hidden')
				const input = (childNodes.item(i).childNodes.item(0) as HTMLSpanElement).innerHTML
				if (!subsettings.includes(input)) {
					addClass(selects, 'hidden')
				}
			}
		}
	}

	const decideImageSubsettings = (imageSubsettings: boolean) => {
		const { imageSubsettingsContainers } = state
		if (!imageSubsettingsContainers) return

		for (let i = 0; i < imageSubsettingsContainers.length; i++) {
			const imageSubsettingsContainer = imageSubsettingsContainers[i]
			if (!imageSubsettingsContainer) continue

			if (imageSubsettings) {
				removeClass(imageSubsettingsContainer, 'hidden')
			} else {
				addClass(imageSubsettingsContainer, 'hidden')
			}
		}
	}

	const getSelectedOption = (select: HTMLSelectElement) => {
		let selectedOption = null
		const { options } = select

		for (let i = 0; i < options.length; i++) {
			if (options[i].selected) {
				selectedOption = options[i].value
				break
			}
		}

		return selectedOption
	}

	const initQuestionnaireSelect = () => {
		const { questionnaireSelect } = state

		if (!questionnaireSelect) return
		questionnaireSelect.addEventListener('change', () => {
			const selectedOption = getSelectedOption(questionnaireSelect)

			// @ts-ignore
			$.nette.ajax({
				type: 'POST',
				url: questionnaireSelect.getAttribute(editor.editorComponentChangeHandler),
				data: {
					questionnaire: selectedOption,
				},
			})
		})
	}

	const initPaginationSelect = () => {
		const { paginationSelect } = state

		if (!paginationSelect) return
		paginationSelect.addEventListener('change', () => {
			const selectedOption = getSelectedOption(paginationSelect)

			// @ts-ignore
			$.nette.ajax({
				type: 'POST',
				url: paginationSelect.getAttribute(editor.editorComponentChangeHandler),
				data: {
					pagination: selectedOption,
				},
			})
		})
	}

	const initShowMoreSelect = () => {
		const { showMoreSelect } = state

		if (!showMoreSelect) return
		showMoreSelect.addEventListener('change', () => {
			const selectedOption = getSelectedOption(showMoreSelect)

			// @ts-ignore
			$.nette.ajax({
				type: 'POST',
				url: showMoreSelect.getAttribute(editor.editorComponentChangeHandler),
				data: {
					showMore: selectedOption,
				},
			})
		})
	}

	const initEditorQuestions = () => {
		const { typeSelects } = state
		if (!typeSelects) return

		for (let i = 0; i < typeSelects.length; i++) {
			const typeSelect = typeSelects[i]
			if (!typeSelect) continue

			typeSelect.addEventListener('change', () => changeSelectOptions(i, typeSelect))
		}
	}
	const init = () => {
		setState({ ...getDynamicTableComponents() })
		initQuestionnaireSelect()
		initEditorQuestions()
		initPaginationSelect()
		initShowMoreSelect()
	}

	return {
		init,
	}
})()
